export enum STATUS {
  SUCCESS = 'success',
}

const convertStatus = (status: number) => {
  switch (status) {
    case 0:
      return 'Mới tạo';
    case 1:
      return 'Chờ phê duyệt';
    case 2:
      return 'Đã phát hành';
    case 3:
      return 'Hết hạn';
    default:
      return '-';
  }
};
export default convertStatus;
